import { useState, useEffect } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useUserByNumber = (userNumber) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userNumber) {
            setLoading(false);
            return;
        }

        const fetchUser = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/users/number/${userNumber}`, 'GET');
                
                if (!response.ok) {
                    if (response.status === 404) {
                        throw new Error('User not found');
                    } else if (response.status === 400) {
                        throw new Error('Invalid user number');
                    } else {
                        throw new Error('Failed to fetch user');
                    }
                }
                
                const data = await response.json();
                setUser(data);
            } catch (error) {
                setError(error.message);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [userNumber]);

    return { user, loading, error };
};
